import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { loginWithSteemKeychain, loginWithUserNameAndPassword, packLoginData } from "../unit/UserUtil";
import { ElLoading } from "element-plus";
export default {
  name: "Login",
  props: ["isHaveKeychain"],
  data: function data() {
    return {
      isUseSteemKeychain: false,
      userName: "",
      password: "",
      isLogin: false,
      isLoginError: false,
      errorMessage: "",
      rememberMe: false,
      loginResult: null,
      isLogining: false,
      loading: null
    };
  },
  methods: {
    onClickRememberMe: function onClickRememberMe(checked) {
      this.rememberMe = checked;
    },
    onClickUseSteemKeychain: function onClickUseSteemKeychain(checked) {
      this.isUseSteemKeychain = checked;
    },
    steemKeychainCallback: function steemKeychainCallback(res) {
      this.loginResult = res;
      this.signDo();
    },
    signDo: function signDo() {
      if (this.loginResult.code == 0) {
        packLoginData(this.userName, this.password, "", "", this.isUseSteemKeychain, this.rememberMe);
        this.$emit("onLoginScuccess");
      } else {
        this.isLoginError = true;
        if (this.loginResult.code == -1) this.errorMessage = "userOrPasswordError";else this.errorMessage = "systemError";
      }

      this.isLogining = false;
      this.loading.close();
    },
    signIn: function signIn() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = ElLoading.service({
                  lock: true,
                  text: "Loading",
                  spinner: "el-icon-loading",
                  background: "rgba(0, 0, 0, 0.7)"
                });

                if (!_this.isLogining) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _this.isLogining = true;

                if (!_this.isUseSteemKeychain) {
                  _context.next = 8;
                  break;
                }

                loginWithSteemKeychain(_this.userName, _this.steemKeychainCallback);
                _context.next = 12;
                break;

              case 8:
                _context.next = 10;
                return loginWithUserNameAndPassword(_this.userName, _this.password);

              case 10:
                _this.loginResult = _context.sent;

                _this.signDo();

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};